import React from "react";

// MUI
import HistoryIcon from "@material-ui/icons/History";
import Tooltip from "@material-ui/core/Tooltip";

// Locals
import Items from "./items";
import HistoryFilter from "./historyFilter";

// Hooks
import useStyles from "./styles";

// Types
import type { HistoryItemType } from "./types";
import Typography from "@material-ui/core/Typography";

interface Props {
  type: "item" | "user";
  data: HistoryItemType[];
  hideTitle?: boolean;
  expandable?: boolean;
  hideFilter?: boolean;
  externalFilterValue?: string;
}

const TimeLine: React.FC<Props> = ({
  hideTitle,
  data,
  expandable = true,
  type,
  hideFilter = false,
  externalFilterValue,
}) => {
  const classes = useStyles();
  const [internalFilterField, setInternalFilterField] = React.useState<string>("All");

  // Use external filter value if provided, otherwise use internal state
  const filterField =
    externalFilterValue !== undefined ? externalFilterValue : internalFilterField;

  const filteredData = React.useMemo(() => {
    const newData = [...data];
    return (filterField === "All"
      ? newData
      : newData.filter((item) => item.field === filterField)
    ).reverse();
  }, [data, filterField]);

  return (
    <div>
      <div className={classes.header}>
        {hideTitle ? (
          <Tooltip title="History of the changes of the item. You can also filter based on the specific field">
            <HistoryIcon className={classes.icon} />
          </Tooltip>
        ) : (
          <Typography className={`myitems-history-title ${classes.title}`}>History</Typography>
        )}
        {!hideFilter && (
          <HistoryFilter type={type} value={filterField} onChange={setInternalFilterField} />
        )}
      </div>
      <Items data={filteredData} expandable={expandable} />
    </div>
  );
};

export default TimeLine;
